export { TypeDefaultSize2XlColorSuccess } from "./TypeDefaultSize2XlColorSuccess";
